import { render, staticRenderFns } from "./packType.vue?vue&type=template&id=49eea539&scoped=true&"
import script from "./packType.vue?vue&type=script&lang=js&"
export * from "./packType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eea539",
  null
  
)

export default component.exports